import React from "react";
const loginContext = React.createContext();
export default loginContext;